import {WebsiteAbstractPageComponent} from "./WebsiteAbstractPageComponent";
import {
    Component
} from "../../../../sedestral/framework/interface/component/Component";
import {WebsiteContentGuideComponent} from "../components/contents/guide/WebsiteContentBlogComponent";
import {Network} from "../../../../network/Network";
import {WebsiteGuideParams} from "../components/black/guide/types/WebsiteGuideParams";

export class WebsiteGuidePage extends WebsiteAbstractPageComponent {

    public guideComponent: WebsiteContentGuideComponent;
    public hashed: boolean;
    public route: string;

    constructor() {
        super();
        this.updateMetas("guide");
        this.status.online = undefined;
        this.noJoin = true;
    }

    contentComponent(): Component {
        this.hashed = false;
        this.route = Network.router.pages.getParam(WebsiteGuideParams.BASE);
        this.guideComponent = new WebsiteContentGuideComponent();
        this.guideComponent.onReady = (post) => this.updateMetasFly(post.title, post.snippet, post.imageUrl, post.url);
        return this.guideComponent;
    }

    onHash(): void {
        let route = Network.router.pages.getParam(WebsiteGuideParams.BASE);
        if (!this.hashed) {
            this.guideComponent.renderAll();
            window.scrollTo({top: 0})
            this.hashed = true;
        } else {
            if (route != this.route) {
                this.guideComponent.renderContent();
                window.scrollTo({top: 0})
            }
        }

        this.route = route;
    }
}